export enum RoleType
{
    Patient = "patient",
    Provider = "provider",
    Admin = "admin"
}
